import React, { useState } from 'react';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import { Link, Redirect } from 'react-router-dom';
import { ForgotPasswordForm } from '@/components/password';
import { useLoginMutation } from '@/queries/auth/useLoginMutation';
import Portal from '../modal';
import { useAuthStore } from '../../stores/auth-store';

export default function Login() {
  const loginMutation = useLoginMutation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [forgotOpen, setForgotOpen] = useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.accountName) {
      errors.accountName = 'Required';
    }
    if (!values.password) {
      errors.password = 'Required';
    }
    return errors;
  };

  const submit = (values) => {
    loginMutation.mutate(values);
  };

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <div className="sign-in-panel mx-auto w-full max-w-[450px] px-2 text-center">
      <div className="glass-panel glass-panel-interactive p-8 sm:p-10">
        <h1 className="mb-8 text-[clamp(1.35rem,2vw+0.8rem,1.85rem)] font-bold text-[#121212]">
          Sign In
        </h1>
        <Formik
          enableReinitialize
          initialValues={{ accountName: '', password: '' }}
          onSubmit={submit}
          validate={validateForm}
        >
          {() => (
            <Form className="admin-form text-left">
              <div className="input-group">
                <label htmlFor="login-account">Email / username</label>
                <Field
                  id="login-account"
                  type="text"
                  name="accountName"
                  placeholder="you@example.com"
                  autoComplete="username"
                />
                <div className="mt-1 text-sm font-bold text-[var(--destructive)]">
                  <ErrorMessage name="accountName" />
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="login-password">Password</label>
                <Field
                  id="login-password"
                  type="password"
                  name="password"
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <div className="mt-1 text-sm font-bold text-[var(--destructive)]">
                  <ErrorMessage name="password" />
                </div>
              </div>
              <div className="mb-2 flex justify-end">
                <button
                  type="button"
                  className="text-sm font-bold text-[var(--bethere-primary)] hover:underline"
                  onClick={() => setForgotOpen(true)}
                >
                  Forgot Password?
                </button>
              </div>
              <button
                type="submit"
                disabled={loginMutation.isPending}
                className="mt-2 inline-flex w-full min-h-[52px] items-center justify-center rounded-[var(--bethere-radius-md)] bg-[var(--bethere-accent)] font-bold text-[#121212] shadow-sm transition hover:bg-[var(--bethere-secondary)] hover:shadow-md disabled:opacity-60"
              >
                Sign In
              </button>
              <p className="mt-6 text-center text-sm text-[var(--festy-muted-text)]">
                Don&apos;t have an account?{' '}
                <Link
                  to="/signup"
                  className="font-bold text-[var(--bethere-primary)] hover:underline"
                >
                  Create one
                </Link>
              </p>
            </Form>
          )}
        </Formik>
      </div>

      <Portal
        header="Reset Password"
        open={forgotOpen}
        onClose={() => setForgotOpen(false)}
      >
        <ForgotPasswordForm onCancel={() => setForgotOpen(false)} />
      </Portal>
    </div>
  );
}
